import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminToastProvider } from "./components/Toast";
import AdminLayout from "./components/AdminLayout";
import { useAuth, hasRole } from "../context/AuthContext";

import AdminDashboardPage from "./pages/AdminDashboardPage";
import AttendanceListPage from "./pages/AttendanceListPage";
import AttendanceAnomalyPage from "./pages/AttendanceAnomalyPage";
import LeaveApprovalPage from "./pages/LeaveApprovalPage";
import EmployeesPage from "./pages/EmployeesPage";
import WorkSchedulePage from "./pages/WorkSchedulePage";
import UsersPage from "./pages/UsersPage";
import RolesPage from "./pages/RolesPage";
import AuditLogPage from "./pages/AuditLogPage";
import MaintenancePage from "./pages/MaintenancePage";
import FeedbackPage from "./pages/FeedbackPage";

/** Batasi halaman ke role tertentu (mis. modul HR hanya SUPER_ADMIN/HR_ADMIN). */
function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (!hasRole(user, ...roles)) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="text-4xl mb-2">🔒</div>
        <p className="text-slate-600">Role Anda tidak berwenang membuka halaman ini.</p>
      </div>
    );
  }
  return children;
}

const HR = ["SUPER_ADMIN", "HR_ADMIN"];

/**
 * Sub-aplikasi ADMIN. Dipasang di App.jsx pada path "/admin/*".
 * Semua route di sini relatif terhadap /admin.
 */
export default function AdminApp() {
  // Lepas kunci lebar mobile (#root max-width 430px) selama di area admin,
  // supaya layout full-width & responsive. Dikembalikan saat keluar dari admin.
  useEffect(() => {
    document.body.classList.add("admin-mode");
    return () => document.body.classList.remove("admin-mode");
  }, []);

  return (
    <AdminToastProvider>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="attendance" element={<AttendanceListPage />} />
          <Route path="attendance/anomalies" element={<AttendanceAnomalyPage />} />
          <Route path="approval/leave" element={<LeaveApprovalPage />} />
          <Route path="employees" element={<RequireRole roles={HR}><EmployeesPage /></RequireRole>} />
          <Route path="work-schedules" element={<RequireRole roles={HR}><WorkSchedulePage /></RequireRole>} />
          <Route path="users" element={<RequireRole roles={HR}><UsersPage /></RequireRole>} />
          <Route path="roles" element={<RequireRole roles={HR}><RolesPage /></RequireRole>} />
          <Route path="audit" element={<RequireRole roles={HR}><AuditLogPage /></RequireRole>} />
          <Route path="feedback" element={<RequireRole roles={HR}><FeedbackPage /></RequireRole>} />
          <Route path="maintenance" element={<RequireRole roles={HR}><MaintenancePage /></RequireRole>} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Routes>
    </AdminToastProvider>
  );
}
